'use strict'

import './ProductGuaranteeCard.css'

import React, { useState } from 'react'
import InfoIcon from "../productServiceCard/images/info-new.svg";

function ProductGuaranteeCard (props) {

  /**
   * Показ / скрытие описания
   */
  function showHidePreview (event) {
    event.preventDefault()
    event.stopPropagation()
    // формируем и показываем окно с описанием
    import(/* webpackPreload: true */ '../../popup')
      .then(module => {
        let popup = new module.Popup('protect-guarantee-advantages-list', true)
        // Устанавливаем тело окна
        popup.body =
          `<div class="protect-guarantee-popup-title">${props.NAME}</div>` +
          `<div class="protect-guarantee-popup-body">${props['PREVIEW_TEXT']}</div>`
        popup.open()
      })
  }

  const active = parseInt(props.checkedWarrantyId) === parseInt(props.ID)

  return (
    <div className="protect-guarantee-list-item">
      <div className="protect-guarantee-content">
        <input type="radio"
               value={props.ID}
               id={`guarantee-${props.ID}`}
               onChange={props.onCheckQuarantee}
               checked={active}/>
        <label htmlFor={`guarantee-${props.ID}`}>
          <div className="protect-guarantee-item-into">
            <span className="protect-guarantee-item-title">
              <span>{props.NAME}</span>
              <span className="open-services-modal">
                <img src={InfoIcon}
                     width={`14px`}
                     height={`14px`}
                     title={`info`}
                     onClick={showHidePreview}
                />
              </span>
            </span>
            <span className="protect-guarantee-item-price">{props.PRICE['PRINT_PRICE']}</span>
          </div>
        </label>
      </div>
    </div>
  )
}

export default ProductGuaranteeCard